// CustomModal.js
import React from "react";
import { useState, useRef, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AuditModalBox({
  isOpen,
  onClose,
  urlpdF,
  setIsCrossClicked,
  setLetterUrl,
}) {
  const [iframeUrl, setIframeUrl] = useState(urlpdF);
  const [isstyle, setstyle] = useState(false);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(600);
  const dialogRef = useRef(null);
  const divRef = useRef(null);
  const [dialogHeight, setDialogHeight] = useState(null);

  //   useEffect(() => {
  //     setIframeUrl(urlpdF);
  //   }, [isOpen]);

  const observedDiv = useRef(null);
  console.log(observedDiv?.current);
  useEffect(
    () => {
      if (!observedDiv.current) {
        // we do not initialize the observer unless the ref has
        // been assigned
        return;
      }

      // we also instantiate the resizeObserver and we pass
      // the event handler to the constructor
      const resizeObserver = new ResizeObserver(() => {
        if (observedDiv.current !== null) {
          if (observedDiv.current.offsetWidth !== width) {
            setWidth(observedDiv.current.offsetWidth);
            divRef.current.style.height = `${
              observedDiv.current.offsetHeight - 100
            }px`;
          }
          if (observedDiv.current.offsetHeight !== height) {
            setHeight(observedDiv.current.offsetHeight);
            if (divRef.current && dialogHeight !== null) {
              divRef.current.style.height = `${observedDiv.current.offsetHeight}px`;
            }
            //divRef.current.style.height = `${observedDiv.current.offsetHeight}px`;
          }
        }
      });

      // the code in useEffect will be executed when the component
      // has mounted, so we are certain observedDiv.current will contain
      // the div we want to observe
      resizeObserver.observe(observedDiv.current);

      // if useEffect returns a function, it is called right before the
      // component unmounts, so it is the right place to stop observing
      // the div
      return function cleanup() {
        resizeObserver.disconnect();
      };
    },
    // only update the effect if the ref element changed
    [observedDiv.current]
  );

  useEffect(() => {
    setposition({ ...position, y: isstyle ? 0 : 200 });
  }, [isstyle]);
  const openModal = () => {
    setstyle(!isstyle);
  };
  const [isDragging, SetisDragging] = useState(false);
  const [position, setposition] = useState({ x: 0, y: 0 });
  const [offset, setoffset] = useState({ x: 0, y: 0 });
  const handleMouseDown = (e) => {
    SetisDragging(true);
    setoffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setposition({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y,
    });
  };
  const handleMouseUp = () => {
    SetisDragging(false);
  };
  if (!isOpen) return null;

  return (
    <dialog
      id="dialog"
      open
      className={`${isstyle ? "full-screen" : ""} draggable-div ${
        isDragging ? "dragging" : ""
      }`}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      ref={observedDiv}
      style={{ left: position.x, top: position.y }}
    >
      <div>
        <h2>Clinical Documents</h2>
        <div id="FAXFILE" className="tab-pane fade active show">
          <iframe
            className="pdf-iframes"
            style={{ height: isstyle ? `${912}px` : "500px" }}
            ref={divRef}
            src={urlpdF}
            loading="lazy"
            // height="100%"
            width="100%"
          ></iframe>
        </div>
        <button aria-label="fullscreen" className="full" onClick={openModal}>
          🖵
        </button>
        <button
          aria-label="close"
          className="x"
          onClick={() => {
            onClose();
            setIsCrossClicked?.(true);
            setLetterUrl?.();
            setstyle(false);
          }}
        >
          ❌
        </button>
      </div>
    </dialog>
  );
}

export default AuditModalBox;
